import { Typography } from '@mui/material';
import { ODSNavigationExternalLink } from '@telekom-ods/react-icons';
import { ODSLink, ODSText } from '@telekom-ods/react-ui-kit';
import { createElement } from 'react';

import { scrollWithOffset } from './scrollWithOffset';

const markdownOptions = {
  forceBlock: true,
  overrides: {
    h1: {
      component: ODSText,
      props: {
        as: 'h1',
        className: 'mark-down-space',
      },
    },
    h2: {
      component: ODSText,
      props: {
        as: 'h2',
        className: 'mark-down-space',
        style: { fontSize: '28px' },
      },
    },
    h3: {
      component: ODSText,
      props: {
        as: 'h3',
        className: 'mark-down-space',
        style: { fontSize: '28px' },
      },
    },
    h4: {
      component: ODSText,
      props: {
        as: 'h4',
        className: 'mark-down-space',
      },
    },
    h5: {
      component: ODSText,
      props: {
        as: 'h5',
        className: 'mark-down-space',
      },
    },
    p: {
      component: ODSText,
      props: {
        as: 'p',
        className: 'p-text mark-down-space',
      },
    },
    ul: {
      component: 'ul',
      props: {
        className: 'mark-down-space',
        style: { margin: '0rem' },
      },
    },
    li: {
      component: Typography,
      props: {
        component: 'li',
        className: 'p-text markdown-list-item',
      },
    },
    td: {
      component: Typography,
      props: {
        component: 'td',
        variant: 'body1',
        style: {
          border: '1px solid #c9c9c9',
          padding: '0 1rem 0 .5rem',
        },
      },
    },
    th: {
      component: Typography,
      props: {
        component: 'th',
        variant: 'body',
        style: {
          border: '1px solid #c9c9c9',
          padding: '0 1rem 0 .5rem',
        },
      },
    },
    table: {
      props: {
        style: { marginBottom: 15 },
      },
    },
    a: {
      component: ODSLink,
      props: {
        rightIcon: createElement(ODSNavigationExternalLink),
        style: {
          display: 'inline',
        },
        onClick: (e: React.MouseEvent<HTMLElement>) => {
          const href = (e.target as HTMLElement).getAttribute('href');
          if (href?.startsWith('#')) {
            e.preventDefault();
            const targetElement = document.getElementById(href.substring(1));
            if (targetElement) {
              scrollWithOffset(targetElement);
            }
          }
        },
      },
    },
  },
};

export { markdownOptions };
